import React from 'react';
import { colors } from '../../styles/colors';

/**
 * Tableau P&L générique
 */
function PLTable({
  title,
  children
}) {
  return (
    <div style={{
      backgroundColor: 'white',
      marginBottom: '2rem',
      border: `1.5px solid ${colors.primary.teal}`,
      borderRadius: '0.5rem',
      overflow: 'hidden',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
      width: '1000px',
      maxWidth: '95vw'
    }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ backgroundColor: colors.primary.teal }}>
            <th style={{
              padding: '0.7rem 1rem',
              textAlign: 'left',
              color: 'white',
              fontWeight: '600',
              fontSize: '0.875rem',
              whiteSpace: 'nowrap'
            }}>
              {title}
            </th>
            {['T1', 'T2', 'T3', 'T4', 'ANNUEL'].map(period => (
              <th key={period} style={{
                padding: '0.75rem 1rem',
                textAlign: 'right',
                color: 'white',
                fontWeight: '600',
                fontSize: '0.875rem',
                whiteSpace: 'nowrap'
              }}>
                {period}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {children}
        </tbody>
      </table>
    </div>
  );
}

export default PLTable;
